import { matchPath, useLocation } from "react-router-dom";

export function useRouteMatch(patterns: readonly string[]) {
    const { pathname } = useLocation();

    for (const element of patterns) {
        const possibleMatch = matchPath(element, pathname);
        if (possibleMatch !== null) {
            return possibleMatch;
        }
    }

    return null;
}